import { rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';

/** 台帳種別のENUM */
enum LedgerClass {
  laContract = '1',
  laArticle = '2',
}

const ledgerClassMap = new Map([
  ['1', LedgerClass.laContract],
  ['2', LedgerClass.laArticle],
]);

function rawValueToLedgerClass(rawValue: string) {
  return rawValueToEnumWithDefault(ledgerClassMap, LedgerClass.laContract)(rawValue);
}

export { LedgerClass, rawValueToLedgerClass };
